'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const fpe=require('pulsar-dashboard-core/dist-es6/extensions/fatiguePointExtensions');
const ae=require('../../../../dist-es6/shared/extensions/assessmentsExtensions');let

ScheduleGraphDirective=class ScheduleGraphDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/directives/scheduleGraphDirective/scheduleGraphTemplate';
}

get objectBindings(){
return[
'interval',
'duties',
'trips',
'flights',
'sleep',
'sleepPromotingIntervals',
'fatigue',
'incidents',
'assessments',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'pastShifts',
'forecastDutyInterval',
'fatigueThreshold',
'dutyLabelFormatter',
'tripLabelFormatter',
'flightLabelFormatter',
'sleepLabelFormatter',
'sleepPromotingLabelFormatter',
'selectedInterval'];

}

get textBindings(){
return[
'useReportStyle'];

}

get controller(){
return ScheduleGraphDirectiveController;
}};let


ScheduleGraphDirectiveController=class ScheduleGraphDirectiveController{
constructor(fatigueMeterTypeContentProviderService){
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this.elementBindings={};

this.plotterVerticalMargin=this.useReportStyle?10:5;

const actualTripHeight=this.useReportStyle?13:32;
this.tripHeight=actualTripHeight+this.plotterVerticalMargin*2;

const actualSleepPromotingHeight=Math.round(actualTripHeight*0.375);
this.sleepPromotingHeight=actualSleepPromotingHeight+this.plotterVerticalMargin*2;

this.incidentPointRadius=this.useReportStyle?8:9.5;
this.assessmentPointRadius=this.useReportStyle?6:7.5;
this.sleepLabelFontStyle=this.useReportStyle?'normal 8px "Open Sans"':null;

this.fatigueStrokeWidth=this.useReportStyle?2:4;
this.fatigueAlertOffsetTop=this.useReportStyle?10:0;

if(!this._fatigueMeterTypeContentProviderService.intervalTypesWithThresholdStatus.includes('duty')){
this.alertIntervalHeight=this.tripHeight;
}

this._alertRanges=this._fatigueMeterTypeContentProviderService.alertsSource==='assessments'?
ae(this.assessments).getAlertRangesFor(TimeInterval.from(_.minDate([this.interval.start,this.now])).to(_.minDate([this.interval.end,this.now]))):
this._alertRanges=fpe(this.fatigue).getAlertRangesOverlapping(this.fatigueThreshold,this._getIntervalsWithVisibleAlertStatus());

this.alertingForecastedDutyIntervals=_.exists(this.forecastDutyInterval)?
TimeInterval.compress(_.compact(this._alertRanges.At.concat(this._alertRanges.Above).map(i=>this.forecastDutyInterval.intersection(i)))):
[];

const timeOfLastScheduleUpdate=_.exists(this.invalidDataWarning)?this.timeOfLastScheduleUpdate:void 0;
const now=!_.exists(this.invalidDataWarning)?
tryGet(this.timeOfLastScheduleUpdate).otherwise(this.now):
this.now;

if(_.exists(timeOfLastScheduleUpdate)&&this.interval.contains(timeOfLastScheduleUpdate)){
this._endOfScheduleMarker=[{time:timeOfLastScheduleUpdate,tooltipText:this.invalidDataWarning}];
}else{
this._endOfScheduleMarker=[];
}

if(this.interval.contains(now)){
this._nowMarker=[now];
}else{
this._nowMarker=[];
}

this._futureMaskStart=this.forecastDutyInterval?this.forecastDutyInterval.end:now;
}

_getIntervalsWithVisibleAlertStatus(){
const{intervalTypesWithThresholdStatus}=this._fatigueMeterTypeContentProviderService;

const intervalsWithVisisbleStatus=[];
if(intervalTypesWithThresholdStatus.includes('duty')){
_.pushMany(intervalsWithVisisbleStatus,this.duties);

if(this.forecastDutyInterval){
intervalsWithVisisbleStatus.push(this.forecastDutyInterval);
}
}

if(intervalTypesWithThresholdStatus.includes('trip')){
_.pushMany(intervalsWithVisisbleStatus,this.trips);
}

if(intervalTypesWithThresholdStatus.includes('flight')){
_.pushMany(intervalsWithVisisbleStatus,this.flights);
}

return intervalsWithVisisbleStatus;
}};


module.exports=ScheduleGraphDirective;
module.exports.DirectiveController=ScheduleGraphDirectiveController;
//# sourceMappingURL=scheduleGraphDirective.js.map
